/* DIVINITY® Theme JS v1.8 — Interactive Cart Drawer + Swipeable Gallery + Image Zoom. v43: light-theme cart drawer colours, currency code for non-USD carts. v44: gallery swipe/thumb swap also updates srcset. v1.7 (theme v46): no silent size pre-select on PDP (size must be chosen unless ?variant= is in the URL), size prompt scrolls into view, country-aware delivery estimate (US 2–5 day transit, Canada range text), Canada duties-included note in cart, Buy-2 bundle nudge in cart drawer. v1.8 (v46 speeddyyy): header cart-count badge is created on the fly when a shopper with an empty cart adds their first item (it previously only existed if the page loaded with items), and the cart button's aria-label stays in sync. */
(function(){
  'use strict';

  var $ = function(sel,ctx){ return (ctx||document).querySelector(sel); };
  var $$ = function(sel,ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); };
  var on = function(el,ev,fn,opts){ if(el) el.addEventListener(ev,fn,opts); };

  function getCountry(){
    try { return (window.Shopify && window.Shopify.country) ? String(window.Shopify.country).toUpperCase() : 'US'; } catch(e){ return 'US'; }
  }

  function initAnnouncer(){
    var r = $('.js-announcer');
    if(!r){
      r = document.createElement('div');
      r.className = 'js-announcer visually-hidden';
      r.setAttribute('aria-live','polite');
      r.setAttribute('aria-atomic','true');
      document.body.appendChild(r);
    }
    window.divinity = window.divinity || {};
    window.divinity.announce = function(msg){
      setTimeout(function(){ r.textContent = msg; },100);
      setTimeout(function(){ r.textContent = ''; },3200);
    };
  }

  function initNavScroll(){
    var nav = $('.site-nav');
    if(!nav) return;
    window.addEventListener('scroll',function(){
      nav.classList.toggle('is-scrolled', window.scrollY > 40);
    },{passive:true});
  }

  function initMobileNav(){
    var nav     = $('.mobile-nav');
    var openBtn = $('.nav-hamburger');
    var closeBtn= $('.mobile-nav-close');
    var overlay = $('.mobile-nav-overlay');
    if(!nav) return;
    function open(){
      nav.classList.add('is-open');
      if(openBtn) openBtn.setAttribute('aria-expanded','true');
      document.body.style.overflow='hidden';
    }
    function close(){
      nav.classList.remove('is-open');
      if(openBtn) openBtn.setAttribute('aria-expanded','false');
      document.body.style.overflow='';
    }
    on(openBtn,'click',open);
    on(closeBtn,'click',close);
    on(overlay,'click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  }

  function initCartDrawer(){
    var drawer  = $('.cart-drawer');
    var overlay = $('.overlay-bg');
    if(!drawer) return;
    function open(){
      refreshCartDrawer(function(){
        drawer.classList.add('is-open');
        if(overlay) overlay.classList.add('is-open');
        document.body.style.overflow='hidden';
      });
    }
    function close(){
      drawer.classList.remove('is-open');
      if(overlay) overlay.classList.remove('is-open');
      document.body.style.overflow='';
    }
    $$('[data-cart-open]').forEach(function(el){ on(el,'click',open); });
    $$('[data-cart-close]').forEach(function(el){ on(el,'click',close); });
    on(overlay,'click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    window.divinity = window.divinity || {};
    window.divinity.openCart = open;
  }

  /* v1.7: the PDP template marks the first available size active on load, which let shoppers add size S without ever choosing. Clear it unless a variant was deliberately linked (?variant=). */
  function initNoSilentSizePreselect(){
    if(!document.getElementById('pdp-form')) return;
    var hasVariantParam = false;
    try { hasVariantParam = new URL(window.location.href).searchParams.has('variant'); } catch(e){}
    if(hasVariantParam) return;
    $$('.size-grid .size-btn').forEach(function(b){
      b.classList.remove('active');
      b.setAttribute('aria-pressed','false');
    });
    var sl = document.getElementById('sticky-size');
    if(sl) sl.textContent = '';
  }

  function initSizeSelection(){
    $$('.size-grid').forEach(function(grid){
      var btns = $$('.size-btn',grid);
      btns.forEach(function(btn){
        if(btn.disabled) return;
        on(btn,'click',function(){
          btns.forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          var sl = $('.sticky-size-label');
          if(sl) sl.textContent = btn.dataset.value || btn.textContent.trim();
          var price = btn.dataset.price;
          if(price){
            var pel = document.getElementById('product-price') || document.getElementById('pdp-price');
            if(pel) pel.textContent = price;
            var spl = document.getElementById('sticky-price');
            if(spl) spl.textContent = price;
          }
          var vid = btn.dataset.variantId;
          if(vid){
            var inp = document.getElementById('variant-id');
            if(inp) inp.value = vid;
            var url = new URL(window.location.href);
            url.searchParams.set('variant',vid);
            window.history.replaceState({},'',url.toString());
          }
          var err = $('.size-error-msg');
          if(err) err.remove();
        });
      });
    });
  }

  /* v1.7: country-aware delivery estimate. Overrides the PDP inline version after it runs. US: 1–2 business days processing + 2–5 day transit. Canada: range text only until real transit data exists. */
  function initDeliveryEstimate(){
    var el = document.getElementById('delivery-estimate-text');
    if(!el) return;
    var country = getCountry();
    function addBusinessDays(date, days){
      var result = new Date(date); var added = 0;
      while(added < days){ result.setDate(result.getDate() + 1); var d = result.getDay(); if(d !== 0 && d !== 6) added++; }
      return result;
    }
    function fmt(date){ return date.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' }); }
    window.updateDeliveryEstimate = function(inStock){
      var t = document.getElementById('delivery-estimate-text');
      if(!t) return;
      if(!inStock){ t.textContent = 'Delivery estimate available once this size ships'; return; }
      if(country === 'CA'){
        t.textContent = 'Ships in 1–2 business days · Canada delivery typically 5–10 business days';
        return;
      }
      var ship = addBusinessDays(new Date(), 2);
      t.textContent = 'Estimated delivery: ' + fmt(addBusinessDays(ship, 2)) + ' – ' + fmt(addBusinessDays(ship, 5));
    };
    var stockText = document.getElementById('stock-text');
    var inStockNow = !(stockText && /restock/i.test(stockText.textContent));
    window.updateDeliveryEstimate(inStockNow);
  }

  function initSizeGuide(){
    var modal = $('.modal-overlay[data-modal="size-guide"]');
    if(!modal) return;
    function open(){ modal.classList.add('is-open'); document.body.style.overflow='hidden'; }
    function close(){ modal.classList.remove('is-open'); document.body.style.overflow=''; }
    $$('[data-open-modal="size-guide"]').forEach(function(el){ on(el,'click',open); });
    $$('[data-close-modal="size-guide"]').forEach(function(el){ on(el,'click',close); });
    on(modal,'click',function(e){ if(e.target===modal) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  }

  function initImageZoom(){
    var modal = $('.zoom-modal');
    var modalImg = modal ? $('img', modal) : null;
    if(!modal || !modalImg) return;

    function open(src, alt){
      modalImg.src = src;
      modalImg.alt = alt || '';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    $$('.gallery-zoom-btn').forEach(function(btn){
      on(btn,'click',function(e){
        e.preventDefault();
        e.stopPropagation();
        var gallery = btn.closest('.product-gallery') || btn.closest('[data-zoom-scope]');
        var img = gallery ? gallery.querySelector('.product-gallery__main img, [data-zoom-image]') : null;
        if(!img) return;
        var largeSrc = img.src.replace(/width=\d+/, 'width=1600');
        open(largeSrc, img.alt);
      });
    });

    on($('.zoom-modal__close'), 'click', close);
    on(modal, 'click', function(e){ if(e.target === modal) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  }

  function initStickyATC(){
    var sticky   = $('.sticky-atc');
    var sentinel = $('[data-atc-sentinel]');
    if(!sticky || !sentinel || !window.IntersectionObserver) return;
    new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },{rootMargin:'0px 0px -80px 0px'}).observe(sentinel);
  }

  function formatMoney(cents, currency){
    var s = '$' + (cents / 100).toFixed(2);
    if(currency && currency !== 'USD') s += ' ' + currency;
    return s;
  }

  /* v1.8: create the header badge if the page loaded with an empty cart, and keep the cart button's aria-label current */
  function syncCartUI(cart){
    var count = cart.item_count || 0;
    $$('.site-nav [data-cart-open]').forEach(function(btn){
      btn.setAttribute('aria-label', 'Open cart (' + count + ' item' + (count === 1 ? '' : 's') + ')');
      if(count > 0 && !btn.querySelector('.cart-count')){
        var badge = document.createElement('span');
        badge.className = 'cart-count';
        badge.setAttribute('aria-hidden','true');
        btn.appendChild(badge);
      }
    });
    $$('.cart-count').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    var title = $('.cart-drawer__title');
    if(title) title.textContent = 'Your cart (' + count + ')';
  }

  function cartChange(key, qty, onDone){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      syncCartUI(cart);
      if(onDone) onDone(cart);
    })
    .catch(function(e){ console.error('DIVINITY cart/change error:', e); });
  }

  function buildCartItemsHTML(cart){
    if(cart.item_count === 0){
      return '<div class="cart-empty">'
        + '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="rgba(26,26,26,0.3)" stroke-width="1" aria-hidden="true">'
        + '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>'
        + '<line x1="3" y1="6" x2="21" y2="6"/>'
        + '</svg>'
        + '<p>Your cart is empty.</p>'
        + '<a href="/products/grace-over-guilt-tee" class="btn btn--ghost-gold" style="font-size:11px;padding:12px 24px;">Shop the tee</a>'
        + '</div>';
    }
    var html = '';
    cart.items.forEach(function(item){
      var key = item.key;
      html += '<div class="cart-drawer__item" data-line-key="'+key+'" style="display:flex;gap:14px;padding:16px 0;border-bottom:0.5px solid rgba(0,0,0,0.08);">';
      html += '<div style="width:72px;height:86px;background:var(--ink-3);border:0.5px solid var(--gold-border);flex-shrink:0;overflow:hidden;">';
      if(item.image) html += '<img src="'+item.image+'" alt="'+item.product_title+'" width="72" height="86" loading="lazy" decoding="async" style="object-fit:cover;width:100%;height:100%;">';
      html += '</div>';
      html += '<div style="flex:1;display:flex;flex-direction:column;gap:6px;min-width:0;">';
      html += '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">';
      html += '<p style="font-size:12px;letter-spacing:0.06em;color:var(--white);margin:0;line-height:1.4;">'+item.product_title+'</p>';
      html += '<button class="cart-remove-btn" data-key="'+key+'" aria-label="Remove '+item.product_title+'" style="background:none;border:none;cursor:pointer;color:rgba(26,26,26,0.55);padding:2px;flex-shrink:0;line-height:1;font-size:18px;transition:color 0.2s;" onmouseover="this.style.color=&#39;#1A1A1A&#39;" onmouseout="this.style.color=&#39;rgba(26,26,26,0.55)&#39;">&times;</button>';
      html += '</div>';
      if(item.variant_title && item.variant_title !== 'Default Title'){
        html += '<p style="font-size:11px;color:var(--text-muted);margin:0;">'+item.variant_title+'</p>';
      }
      html += '<p class="cart-item-price" style="font-size:12px;color:var(--gold);margin:0;">'+formatMoney(item.final_line_price, cart.currency)+'</p>';
      html += '<div class="cart-qty-ctrl" data-key="'+key+'" style="display:flex;align-items:center;gap:0;margin-top:2px;border:0.5px solid rgba(0,0,0,0.18);width:fit-content;">';
      html += '<button class="cart-qty-minus" data-key="'+key+'" data-qty="'+(item.quantity-1)+'" aria-label="Decrease quantity" style="background:none;border:none;cursor:pointer;color:var(--white);width:28px;height:28px;font-size:15px;display:flex;align-items:center;justify-content:center;transition:color 0.2s;">&#8722;</button>';
      html += '<span class="cart-qty-val" style="font-size:12px;color:var(--white);font-family:var(--serif);width:24px;text-align:center;line-height:28px;">'+item.quantity+'</span>';
      html += '<button class="cart-qty-plus" data-key="'+key+'" data-qty="'+(item.quantity+1)+'" aria-label="Increase quantity" style="background:none;border:none;cursor:pointer;color:var(--white);width:28px;height:28px;font-size:15px;display:flex;align-items:center;justify-content:center;transition:color 0.2s;">&#43;</button>';
      html += '</div>';
      html += '</div></div>';
    });
    return html;
  }

  /* v1.7: country-aware shipping/tax note + Buy-2 bundle nudge in the drawer footer */
  function updateCartFooterExtras(cart){
    var footer = $('.cart-drawer__footer');
    if(!footer) return;
    var note = footer.querySelector('p');
    if(note){
      note.textContent = getCountry() === 'CA'
        ? 'Shipping\u2019s on us \u2014 free shipping on every order. Price includes duties & taxes \u2014 nothing extra at delivery.'
        : 'Shipping\u2019s on us \u2014 free shipping on every order, US & Canada. Taxes calculated at checkout.';
    }
    var nudge = footer.querySelector('.cart-bundle-nudge');
    if(!nudge){
      nudge = document.createElement('div');
      nudge.className = 'cart-bundle-nudge';
      nudge.style.cssText = 'font-size:11.5px;line-height:1.5;letter-spacing:0.02em;padding:10px 12px;border:0.5px solid rgba(0,0,0,0.12);display:flex;align-items:center;justify-content:space-between;gap:10px;';
      var checkoutBtn = footer.querySelector('#cart-checkout-btn');
      if(checkoutBtn) footer.insertBefore(nudge, checkoutBtn); else footer.appendChild(nudge);
    }
    var qty = 0; var firstKey = null; var firstQty = 0;
    (cart.items || []).forEach(function(item){ qty += item.quantity; if(!firstKey){ firstKey = item.key; firstQty = item.quantity; } });
    if(qty === 1 && firstKey){
      nudge.style.display = 'flex';
      nudge.innerHTML = '<span style="color:var(--white);">Add 1 more tee and save 10% \u2014 applied automatically.</span>'
        + '<button type="button" class="cart-bundle-add" style="background:none;border:0.5px solid currentColor;padding:6px 10px;font-size:10.5px;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;white-space:nowrap;color:var(--white);">+ Add one</button>';
      var addBtn = nudge.querySelector('.cart-bundle-add');
      on(addBtn,'click',function(){
        addBtn.disabled = true; addBtn.textContent = 'Adding\u2026';
        cartChange(firstKey, firstQty + 1, function(){ refreshCartDrawer(); });
      });
    } else if(qty >= 2){
      nudge.style.display = 'flex';
      nudge.innerHTML = '<span style="color:#2E7D4F;">\u2713 Bundle savings: 10% off 2+ tees, applied at checkout.</span>';
    } else {
      nudge.style.display = 'none';
      nudge.innerHTML = '';
    }
  }

  function refreshCartDrawer(callback){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var body = $('.cart-drawer__body');
      if(!body) return;
      body.innerHTML = buildCartItemsHTML(cart);
      syncCartUI(cart);
      var totalEl = $('.cart-drawer__total-val');
      if(totalEl) totalEl.textContent = formatMoney(cart.total_price, cart.currency);
      var footer = $('.cart-drawer__footer');
      if(footer) footer.style.display = cart.item_count > 0 ? '' : 'none';
      updateCartFooterExtras(cart);
      wireCartControls();
      if(callback) callback(cart);
    })
    .catch(function(e){ console.error('DIVINITY cart refresh error:', e); });
  }

  function wireCartControls(){
    var body = $('.cart-drawer__body');
    if(!body) return;
    $$('.cart-remove-btn', body).forEach(function(btn){
      on(btn,'click',function(){
        var key = btn.dataset.key;
        var item = btn.closest('.cart-drawer__item');
        if(item) item.style.opacity = '0.4';
        cartChange(key, 0, function(){ refreshCartDrawer(); });
      });
    });
    $$('.cart-qty-minus', body).forEach(function(btn){
      on(btn,'click',function(){
        var key = btn.dataset.key;
        var newQty = parseInt(btn.dataset.qty, 10);
        if(newQty < 0) newQty = 0;
        btn.disabled = true;
        var plusBtn = body.querySelector('.cart-qty-plus[data-key="'+key+'"]');
        if(plusBtn) plusBtn.disabled = true;
        if(newQty === 0){ var item = btn.closest('.cart-drawer__item'); if(item) item.style.opacity = '0.4'; }
        cartChange(key, newQty, function(){ refreshCartDrawer(); });
      });
    });
    $$('.cart-qty-plus', body).forEach(function(btn){
      on(btn,'click',function(){
        var key = btn.dataset.key;
        var newQty = parseInt(btn.dataset.qty, 10);
        btn.disabled = true;
        var minusBtn = body.querySelector('.cart-qty-minus[data-key="'+key+'"]');
        if(minusBtn) minusBtn.disabled = true;
        cartChange(key, newQty, function(){ refreshCartDrawer(); });
      });
    });
  }

  function addToCart(variantId, quantity, btn){
    if(!variantId){ return; }
    var origText = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function(res){ if(!res.ok) throw new Error('Cart error: ' + res.status); return res.json(); })
    .then(function(){
      if(btn){
        btn.textContent = 'Added ✓';
        btn.style.background = '#2a4a2a';
        btn.style.color = '#fff';
        setTimeout(function(){
          btn.textContent = origText;
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 2000);
      }
      if(window.divinity && window.divinity.announce) window.divinity.announce('Added to cart');
      if(window.divinity && window.divinity.openCart){
        window.divinity.openCart();
      } else {
        fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(syncCartUI).catch(function(){});
      }
    })
    .catch(function(err){
      console.error('DIVINITY ATC error:', err);
      if(btn){
        btn.textContent = 'Error — try again';
        btn.style.background = '#4a2a2a';
        btn.style.color = '#fff';
        btn.disabled = false;
        setTimeout(function(){
          btn.textContent = origText;
          btn.style.background = '';
          btn.style.color = '';
        }, 3000);
      }
    });
  }

  function initATCButtons(){
    $$('[data-atc]').forEach(function(btn){
      on(btn,'click',function(e){
        e.preventDefault();
        var grid = document.querySelector('.size-grid');
        if(grid){
          var active = grid.querySelector('.size-btn.active');
          if(!active){
            var existing = document.querySelector('.size-error-msg');
            if(!existing){
              var msg = document.createElement('p');
              msg.className = 'size-error-msg';
              msg.setAttribute('role','alert');
              msg.textContent = 'Please select a size before adding to cart.';
              msg.style.cssText = 'font-size:12px;color:#B3261E;letter-spacing:0.06em;margin-top:-8px;font-family:var(--serif);';
              grid.parentNode.insertBefore(msg, grid.nextSibling);
              setTimeout(function(){ if(msg.parentNode) msg.parentNode.removeChild(msg); }, 4000);
            }
            try { grid.scrollIntoView({ behavior:'smooth', block:'center' }); } catch(err){ grid.scrollIntoView(); }
            return;
          }
        }
        var variantInput = document.getElementById('variant-id');
        var variantId    = variantInput ? variantInput.value : null;
        if(grid){ var ab = grid.querySelector('.size-btn.active'); if(ab && ab.dataset.variantId) variantId = ab.dataset.variantId; }
        if(!variantId){ console.warn('DIVINITY: no variant ID found'); return; }
        var qtyInput = document.querySelector('input[name="quantity"]');
        var qty = qtyInput ? (parseInt(qtyInput.value,10) || 1) : 1;
        addToCart(variantId, qty, btn);
      });
    });
  }

  function initQtyControls(){
    $$('.qty-control').forEach(function(ctrl){
      var minus = $('.qty-minus',ctrl);
      var plus  = $('.qty-plus',ctrl);
      var input = ctrl.querySelector('input[type="number"]');
      if(!minus||!plus||!input) return;
      on(minus,'click',function(){ var v = parseInt(input.value,10)||1; if(v>1) input.value = v-1; });
      on(plus,'click',function(){ var v = parseInt(input.value,10)||1; input.value = v+1; });
    });
  }

  function initProductGallery(){
    $$('.product-gallery').forEach(function(gallery){
      var mainWrap = $('.product-gallery__main', gallery);
      var mainImg  = $('.product-gallery__main img', gallery);
      var thumbs   = $$('.product-gallery__thumb', gallery).filter(function(t){ return t.dataset.mediaType !== 'video'; });
      if(!mainWrap || !mainImg || !thumbs.length) return;

      var slides = thumbs.map(function(t){
        return { src: t.dataset.src, srcset: t.dataset.srcset, alt: t.dataset.alt, thumb: t };
      });

      var currentIndex = 0;
      var activeThumb = gallery.querySelector('.product-gallery__thumb.active');
      if(activeThumb){
        var startIdx = thumbs.indexOf(activeThumb);
        if(startIdx > -1) currentIndex = startIdx;
      }

      function goTo(index){
        if(!slides.length) return;
        if(index < 0) index = slides.length - 1;
        if(index >= slides.length) index = 0;
        currentIndex = index;
        var slide = slides[currentIndex];
        if(slide.srcset){ mainImg.srcset = slide.srcset; } else { mainImg.removeAttribute('srcset'); }
        if(slide.src) mainImg.src = slide.src;
        if(slide.alt) mainImg.alt = slide.alt;
        mainImg.style.display = '';
        $$('.product-gallery__thumb', gallery).forEach(function(t){ t.classList.remove('active'); });
        if(slide.thumb) slide.thumb.classList.add('active');
        var dots = $$('.product-gallery__dot', gallery);
        dots.forEach(function(d,i){ d.classList.toggle('active', i === currentIndex); });
      }

      thumbs.forEach(function(thumb, i){
        on(thumb,'click',function(){ goTo(i); });
      });

      if(slides.length < 2) return;

      var touchStartX = 0, touchStartY = 0, isTouching = false;
      on(mainWrap,'touchstart',function(e){
        var t = e.changedTouches[0];
        touchStartX = t.clientX; touchStartY = t.clientY; isTouching = true;
      },{passive:true});
      on(mainWrap,'touchend',function(e){
        if(!isTouching) return;
        isTouching = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - touchStartX;
        var dy = t.clientY - touchStartY;
        if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          goTo(currentIndex + (dx < 0 ? 1 : -1));
        }
      },{passive:true});

      var mouseStartX = 0, isDragging = false;
      on(mainWrap,'mousedown',function(e){
        mouseStartX = e.clientX;
        isDragging = true;
        mainWrap.classList.add('is-dragging');
        e.preventDefault();
      });
      on(window,'mouseup',function(e){
        if(!isDragging) return;
        isDragging = false;
        mainWrap.classList.remove('is-dragging');
        var dx = e.clientX - mouseStartX;
        if(Math.abs(dx) > 60){ goTo(currentIndex + (dx < 0 ? 1 : -1)); }
      });

      mainWrap.setAttribute('tabindex','0');
      mainWrap.setAttribute('role','region');
      mainWrap.setAttribute('aria-label','Product image gallery — use left and right arrow keys to browse');
      on(mainWrap,'keydown',function(e){
        if(e.key === 'ArrowLeft'){ goTo(currentIndex - 1); }
        else if(e.key === 'ArrowRight'){ goTo(currentIndex + 1); }
      });
    });
  }

  function initEmailPopup(){ /* noop — pop-up lives in sections/signup-popup.liquid */ }

  function initEmailForms(){
    $$('.js-email-form').forEach(function(form){
      on(form,'submit',function(){
        var btn = form.querySelector('button[type="submit"], .email-submit');
        if(btn){ btn.textContent = 'Done ✓'; btn.style.background = '#2a4a2a'; }
      });
    });
  }

  function initScrollReveal(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if(!window.IntersectionObserver) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting) entry.target.classList.add('is-visible');
      });
    },{threshold:0.1});
    $$('.reveal').forEach(function(el){ io.observe(el); });
  }

  function boot(){
    initAnnouncer();
    initNavScroll();
    initMobileNav();
    initCartDrawer();
    initNoSilentSizePreselect();
    initSizeSelection();
    initDeliveryEstimate();
    initSizeGuide();
    initImageZoom();
    initStickyATC();
    initATCButtons();
    initQtyControls();
    initProductGallery();
    initEmailPopup();
    initEmailForms();
    initScrollReveal();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();